import { GenericErrorBoundary } from 'components/common-form/builder/form/GenericErrorBoundary';
import { AppCrashedFallback } from 'components/FatalError/AppCrashFallback';
import { StaticMain } from 'components/staticForm/main';
import { TabIdProps } from 'shared/props';

export function StaticQuotesTab({ tabId }: TabIdProps) {
  return (
    <div className="flex-grow-1 w-100 min-h-0 bg-lvl3">
      <GenericErrorBoundary Fallback={AppCrashedFallback} key={tabId} context={{ tabId }}>
        <StaticMain formId={tabId} />
      </GenericErrorBoundary>
    </div>
  );
}

StaticQuotesTab.displayName = 'StaticQuotesTab';
